import React, { memo } from 'react'
import {
  ButtonGroup,
  ButtonToolbar,
  Form,
  Modal,
  Button,
} from 'react-bootstrap'

const CreateSeriesModal = ({ show, onHide, value, onChange, onSubmit }) => (
  <Modal show={show} onHide={onHide} centered>
    <Modal.Header closeButton>
      <Modal.Title>Add a new series</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Form.Control
        type='text'
        placeholder='Enter series name'
        value={value}
        onChange={onChange}
      />
    </Modal.Body>
    <Modal.Footer>
      <ButtonToolbar>
        <ButtonGroup className='me-2'>
          <Button variant='primary' onClick={onHide}>
            Cancel
          </Button>
        </ButtonGroup>
        <ButtonGroup className='me-2'>
          <Button variant='primary' onClick={onSubmit}>
            Save
          </Button>
        </ButtonGroup>
      </ButtonToolbar>
    </Modal.Footer>
  </Modal>
)

export default memo(CreateSeriesModal)
